import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M15.502 10.783A8 8 0 0 0 16 8c0-.979-.176-1.916-.498-2.783L8 4.522l-7.502.695A8 8 0 0 0 0 8c0 .979.176 1.916.498 2.783L8 11.478z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D80027",
      d: "M8 16a8 8 0 0 0 7.502-5.217H.498A8 8 0 0 0 8 16M8 0A8 8 0 0 0 .498 5.217h15.004A8 8 0 0 0 8 0"
    }, null, -1)
  ])))
}
export default { render: render }